













































































































import {Vue, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {Mall} from 'supporter';
import {DisplayEnum} from '@/types/enum';
const qs = require('qs');
import { getLocalStorageMalls, toI18n } from '@/utils/commonUtils';

@Component({
  components: {
    PageFormSelect
  }
})
export default class CopyMallProduct extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private mallInfo: Mall[] = getLocalStorageMalls();

  private get malls(): DisplayEnum[] {
    return this.mallInfo.map(
      (mall: Mall): DisplayEnum => {
        return {value: mall.mallNo.toString(), label: mall.mallName};
      }
    );
  }

  private mallNoChange() {
    if (this.isSameMall(this.formData.mallNo)) {
      this.copyReviewDisabled = false;
    } else {
      this.copyReviewDisabled = true;

      Object.assign(this.formData, {copyReviewYn: 'N'});
    }
  }

  private formData = {
    mallNo: '',
    syncStockYn: 'N',
    copyStockCntYn: 'N',
    copyReviewYn: 'N'
  };

  private syncStockDisabled = false;
  private copyStockCntDisabled = false;
  private copyReviewDisabled = false;

  private copyProductBtn() {
    window.opener.postMessage({copyWin: true, url: `/product/copy/${this.$route.query.mallProductNo}?${qs.stringify(this.formData)}`});
    this.close();
  }

  private close() {
    window.close();
  }

  private initCopyBtns() {
    if (this.$route.query.itemYn && this.$route.query.itemYn === 'Y') {
      this.syncStockDisabled = true;
      this.copyStockCntDisabled = true;
      this.copyReviewDisabled = true;
    } else {
      this.copyStockCntDisabled = false;
      this.copyReviewDisabled = true;
    }
  }

  private isSameMall(selectedMallNo: string) {
    const targetMallNo = String(this.$route.query.mallNo);
    return targetMallNo === selectedMallNo;
  }

  private syncStockToggle() {
    const isSync = this.formData.syncStockYn === 'Y';

    if (isSync) {
      this.copyStockCntDisabled = true;
      Object.assign(this.formData, {copyStockCntYn: 'Y'});
      this.isSameMall(this.formData.mallNo) ? (this.copyReviewDisabled = false) : (this.copyReviewDisabled = true);
    } else {
      Object.assign(this.formData, {copyReviewYn: 'N'});
      this.copyStockCntDisabled = false;
      this.copyReviewDisabled = true;
    }
  }
  private created() {
    document.body.classList.add('popup', 'popup_medium');
    Object.assign(this.formData, {mallNo: this.$route.query.mallNo});
    this.initCopyBtns();
    window.name = 'copyMallProductWin';
  }
}
